import axios from 'axios';
import { TListFemale, TFemaleDetail, TFilterFemale } from 'types';

const getFemaleList = async (payload: {
  filter: TFilterFemale;
  currentPage: number;
  pageSize: number;
}): Promise<TListFemale> => {
  const { currentPage, pageSize, filter } = payload;
  const { keywords, schedules, discount, ...res } = filter;
  return await axios
    .post('female/filter', {
      currentPage,
      pageSize,
      ...res,
      startTime: schedules.startTime,
      endTime: schedules.endTime,
      groupCoupon: discount.groupCoupon,
      searchString: keywords,
    })
    .then(function (response) {
      return response.data;
    });
};

const getFemaleListDiscount = async (payload: {
  filter: TFilterFemale;
  currentPage: number;
  pageSize: number;
}): Promise<TListFemale> => {
  const { currentPage, pageSize, filter } = payload;
  const { keywords, schedules, discount, ...res } = filter;

  return await axios
    .post('female/list-discount', {
      currentPage,
      pageSize,
      ...res,
      searchString: keywords,
    })
    .then(function (response) {
      return response.data;
    });
};

const getFemaleDetail = async (id: number): Promise<TFemaleDetail> => {
  const res = await axios.get(`female/profile/${id}`).then(function (response) {
    return response.data;
  });
  return res;
};

const getFemaleRecommendList = async (payload: {
  filter: TFilterFemale;
  currentPage: number;
  pageSize: number;
}): Promise<TListFemale> => {
  const { currentPage, pageSize, filter } = payload;
  const { keywords, schedules, discount, ...res } = filter;
  return await axios
    .post('female/recommend-list', {
      currentPage,
      pageSize,
      ...res,
      searchString: keywords,
    })
    .then(function (response) {
      return response.data;
    });
};

export {
  getFemaleList,
  getFemaleDetail,
  getFemaleListDiscount,
  getFemaleRecommendList,
};
